import { Component, Input } from '@angular/core';

@Component({
    selector: 'googleMap',
    templateUrl: 'googleMap.component.html',
    styles: [
        `agm-map {height: 400px;width: 100%;}`
    ]
})
export class GoogleMapComponent {

    // google maps zoom level
    zoom: number = 16;
    // initial center position for the map
    @Input() lat: number=0;
    @Input() lng: number=0;
}